import { useRouter } from "next/router";
import { getAlternateLocaleByCode } from "@common/types/Locale";
import useUpdateUserLanguageMutation from "@modules/user/hooks/useUpdateUserLanguageMutation";
import Button from "./Button";

const LocaleButton = () => {
  const router = useRouter();
  const { dealId } = router.query;
  const linkLocale = getAlternateLocaleByCode(router.locale || "en");
  const useUpdateUserLanguage = useUpdateUserLanguageMutation();

  const handleLocaleChange = () => {
    router.push(router.asPath, router.asPath, { locale: linkLocale.code });
    useUpdateUserLanguage.mutate({
      locale: linkLocale.code,
      dealId: dealId?.toString(),
    });
  };

  return (
    <Button
      fill="outline"
      buttonStyle="transparent"
      spacing="tight-hug"
      size="small"
      onClick={handleLocaleChange}
    >
      {linkLocale.code.toLocaleUpperCase()}
    </Button>
  );
};

export default LocaleButton;
